export function lithuanianToday(now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Vilnius', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
  const value = type => Number(parts.find(part => part.type === type).value);
  return new Date(Date.UTC(value('year'), value('month') - 1, value('day')));
}

export function easterSunday(year) {
  const a = year % 19, b = Math.floor(year / 100), c = year % 100;
  const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451), n = h + l - 7 * m + 114;
  return new Date(Date.UTC(year, Math.floor(n / 31) - 1, n % 31 + 1));
}

export function isWorkingDay(date) {
  if (date.getUTCDay() === 0 || date.getUTCDay() === 6) return false;
  const key = `${date.getUTCMonth() + 1}-${date.getUTCDate()}`;
  if (['1-1', '2-16', '3-11', '5-1', '6-24', '7-6', '8-15', '11-1', '11-2', '12-24', '12-25', '12-26'].includes(key)) return false;
  const easterMonday = easterSunday(date.getUTCFullYear());
  easterMonday.setUTCDate(easterMonday.getUTCDate() + 1);
  return date.getTime() !== easterMonday.getTime();
}

export function addWorkingDays(date, count) {
  const result = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
  for (let remaining = count; remaining > 0;) {
    result.setUTCDate(result.getUTCDate() + 1);
    if (isWorkingDay(result)) remaining--;
  }
  return result;
}

export function parseDeliveryTerm(text) {
  const normalized = String(text || '').toLowerCase().replace(/\u00a0/g, ' ').trim();
  const match = normalized.match(/^(?:per\s+|iki\s+)?(\d{1,3})(?:\s*[-–—]\s*(\d{1,3}))?\s*(?:d\s*\.\s*d\s*\.?|darbo\s+dien(?:as|os|ų|a|ą))\s*\.?$/u);
  if (!match) return null;
  const min = match[2] ? Number(match[1]) : 1;
  const max = Number(match[2] || match[1]);
  return min > 0 && max >= min && max <= 365 ? { min, max } : null;
}

export function deliveryRange(term, today = lithuanianToday()) {
  const days = parseDeliveryTerm(term);
  return days ? { start: addWorkingDays(today, days.min), end: addWorkingDays(today, days.max) } : null;
}

export function formatDeliveryRange({ start, end }, locale = 'lt') {
  if (locale.startsWith('lt')) {
    const months = ['Saus.', 'Vas.', 'Kov.', 'Bal.', 'Geg.', 'Birž.', 'Liep.', 'Rugp.', 'Rugs.', 'Spal.', 'Lapkr.', 'Gruod.'];
    if (start.getUTCFullYear() !== end.getUTCFullYear()) return `${start.toISOString().slice(0, 10)} – ${end.toISOString().slice(0, 10)}`;
    const first = `${months[start.getUTCMonth()]} ${start.getUTCDate()}`;
    if (start.getTime() === end.getTime()) return `${first} d.`;
    return start.getUTCMonth() === end.getUTCMonth() ? `${first}–${end.getUTCDate()} d.` : `${first} – ${months[end.getUTCMonth()].toLowerCase()} ${end.getUTCDate()} d.`;
  }
  const formatter = new Intl.DateTimeFormat(locale, { timeZone: 'UTC', month: 'short', day: 'numeric', ...(start.getUTCFullYear() !== end.getUTCFullYear() ? { year: 'numeric' } : {}) });
  return start.getTime() === end.getTime() ? formatter.format(start) : formatter.formatRange(start, end);
}

if (typeof window !== 'undefined' && !customElements.get('dama-delivery-estimate')) {
  customElements.define('dama-delivery-estimate', class extends HTMLElement {
    connectedCallback() {
      this.render = this.render.bind(this);
      this.render();
      this.timer = window.setInterval(this.render, 60000);
      document.addEventListener('visibilitychange', this.render);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.render);
    }

    render() {
      const target = this.querySelector('[data-delivery-dates]');
      if (!target) return;
      const range = this.dataset.available === 'true' ? deliveryRange(this.dataset.term) : null;
      const text = range ? formatDeliveryRange(range, this.dataset.locale) : this.dataset.available === 'true' ? this.dataset.unknown : this.dataset.unavailable;
      if (target.textContent !== text) target.textContent = text;
      if (range) {
        target.dataset.start = range.start.toISOString().slice(0, 10);
        target.dataset.end = range.end.toISOString().slice(0, 10);
        target.setAttribute('aria-label', `${this.dataset.estimateLabel}: ${text}`);
      } else {
        delete target.dataset.start;
        delete target.dataset.end;
        target.removeAttribute('aria-label');
      }
    }
  });
}
